<template>
  <div class="app-container">
    <list ref="list" :can-price="canPrice">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus"
          >添加</el-button
        >
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template slot-scope="{ row }">
            <template v-if="row.Status < 2">
              <template v-if="$permission.canWrite()">
                <el-button type="text" @click.stop="edit(row)">编辑</el-button>
              </template>
            </template>
            <el-button type="text" v-else @click.stop="details(row)"
              >查看</el-button
            >
            <!-- <el-button
              v-if="$permission.canWrite()"
              type="text"
              @click="edit(row)"
              >审核</el-button
            > -->
          </template>
        </el-table-column>
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog" @close-saved="reload" /> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/business/sales/saleinvoice/list";
// import editDialog from "@/components/business/purchase/inquiry/editDialog";

export default {
  name: "saleinvoice",
  mixins: [curdMixins],
  components: {
    list,
    // editDialog,
  },

  computed: {
    canPrice() {
      return this.$permission.canPrice();
    },
  },
  methods: {
    // path:"/business/purchase/inquiry"

    create() {
      this.$router.push({
        name: "editSaleInvoice",
        params: { mode: "create" },
      });
    },
    edit(data) {
      this.$router.push({
        name: "editSaleInvoice",
        params: { mode: "edit", data },
      });
    },
    details(data) {
      this.$router.push({
        name: "editSaleInvoice",
        params: { mode: "details", data },
      });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.DocId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>
